const styles = ({ COLORS }) => ({
  status: {
    display: 'flex',
    margin: '30px 0 20px',
    '& p a': {
      color: COLORS.BLUE.NORMAL,
      textDecoration: 'none',
      fontWeight: 'bold'
    }
  },
  msg: {
    marginTop: '2px'
  }
})

export default styles
